import {useHierarchyNavAccess} from '@domain/kpis'
import {Grid} from '@mui/material'
import {
  AREA_QUICK_SELECT_SLOTS,
  AreaDashboardContainer,
  AreaFilterContainer,
  type AreaNavigation,
  useMapMarkersData
} from '@widgets/area-dashboard'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'
import {AreaProcessEngineerCardContainer} from '../containers'

type Props = {
  dashboardRoute: string
  navigation: AreaNavigation
  fallbackBreadcrumbs?: React.ReactNode
  useMapMarkersDataHook?: typeof useMapMarkersData
}

export const ProcessEngineerAreaDashboard = ({
  dashboardRoute,
  navigation,
  fallbackBreadcrumbs,
  useMapMarkersDataHook = useMapMarkersData
}: Props) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const {allowedAreas, getAreaById} = useHierarchyNavAccess('VIEW_PROCESS_ENGINEER_DASHBOARD')

  return (
    <AreaDashboardContainer
      dashboardTitle={t('areaDashboard.pageTitle')}
      dashboardRoute={dashboardRoute}
      navigation={navigation}
      permission="VIEW_PROCESS_ENGINEER_DASHBOARD"
      useMapMarkersDataHook={useMapMarkersDataHook}
      useAccessHook={useHierarchyNavAccess}
      allowedAreas={allowedAreas}
      getAreaById={getAreaById}
      fallbackBreadcrumbs={fallbackBreadcrumbs}
      getPlantCards={(args: PlantCardsListProps) => (
        <PlantCardsList {...args} getPlantLink={navigation.getPlantLink} />
      )}
      headerActionContent={
        <AreaFilterContainer quickSelectSlots={AREA_QUICK_SELECT_SLOTS} defaultSlot="today" />
      }
    />
  )
}

type PlantCardsListProps = {
  plantIds: string[]
  spacing?: number
  columnsCount?: number
  kpiGridItemXs?: number
}

const COLUMN_SIZE = 1

const PlantCardsList = ({
  plantIds,
  getPlantLink,
  spacing = 2,
  columnsCount = 1,
  kpiGridItemXs = 4
}: PlantCardsListProps & {getPlantLink: AreaNavigation['getPlantLink']}) => {
  return (
    <Grid container spacing={spacing} columns={columnsCount * COLUMN_SIZE}>
      {plantIds.map((plantId) => (
        <Grid item xs={COLUMN_SIZE} key={plantId}>
          <AreaProcessEngineerCardContainer
            plantId={plantId}
            plantLink={getPlantLink(plantId)}
            cardBoxSx={{width: '100%'}}
            kpiGridItemXs={kpiGridItemXs}
          />
        </Grid>
      ))}
    </Grid>
  )
}
